<template>
  <div class="flex">
    <div
      v-for="(o, index) of dates"
      :key="setupId + '-date-' + index"
      class="mr-2"
    >
      <div class="mt-4">
        <flat-pickr
          :config="datePickerConfigStart"
          v-model="o.date"
          placeholder="Choose date"
          class="p-3 s-inputx vs-input--input flex"
          @on-change="(newDate) => setDate(o)"
          :disabled="disableComponent"
        />
      </div>
    </div>
    <vs-button
      :disabled="disableComponent"
      size="small"
      class="mt-4"
      @click="addDate()"
      >Add date</vs-button
    >
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    flatPickr,
  },
  props: {
    calendarEntry: Object,
    setupId: String,
    disableComponent: Boolean,
  },
  model: {
    prop: "calendarEntry",
    event: "calendarEntry-updated",
  },
  data() {
    return {
      //dates: [],
      datePickerConfigStart: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "Y-m-d", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
    };
  },
  computed: {
    dates() {
      return this.calendarEntry.dates.map((d, index) => {
        return { date: d, index: index };
      });
    },
  },
  methods: {
    addDate() {
      this.calendarEntry.dates.push(undefined);
    },
    setDate(objectWithDateAndIndex) {
      let date = moment(objectWithDateAndIndex.date);
      date = moment.utc([date.year(), date.month(), date.date()]);

      this.calendarEntry.dates.splice(
        objectWithDateAndIndex.index,
        1,
        date.format("YYYY-MM-DD")
      );
    },
  },
};
</script>

<style scoped>
</style>
